import { FC } from "react";
// 组件
import OptionItem from "./optionItem";
// 常量
import { OptionsProps } from "../../interface";

/** 列展示 */
const Options: FC<OptionsProps> = props => {
  const { options, statue, record, } = props;
  return (
    <div className="card-table-column-container">
      {
        options?.map((line, lineIndex) => {
          return (
            <div className="column-line" key={lineIndex}>
              {
                line.map((item, itemIndex) => {
                  return (
                    <OptionItem
                      key={item.name || itemIndex}
                      {...item}
                      statue={statue}
                      record={record}
                    />
                  );
                })
              }
            </div>
          )
        })
      }
    </div>
  );
};

export default Options;
